import React, { useContext } from "react";
import { Container, Option } from "./closed.styles";
import CurrentQuestionContext from "../../../contexts/CurrentQuestionContext";
import { GoToScreen } from "../../../constants/closedQuestionActions";

const Closed = ({ isSuccessText }) => {
  const currQuestionIndex = useContext(CurrentQuestionContext)
    .currQuestionIndex;
  const options = useContext(CurrentQuestionContext).question.options;
  const setNextQuestion = useContext(CurrentQuestionContext).setNextQuestion;
  const setSpecificQuestion = useContext(CurrentQuestionContext)
    .setSpecificQuestion;
  let startTime = new Date();

  const getOptionActionString = (action, answer) => {
    let actionString = "";
    let actionParameter = "";
    if (action) {
      const indexOfActionStringActionEnd = action.indexOf("(");
      actionString = action.slice(0, indexOfActionStringActionEnd);
      actionParameter = action.substring(
        action.lastIndexOf("(") + 1,
        action.lastIndexOf(")")
      );
    }

    makeAction(actionString, actionParameter, answer);
  };

  const makeAction = (actionString, actionParameter, answer) => {
    const timer = new Date() - startTime;

    switch (actionString) {
      case GoToScreen:
        setSpecificQuestion(actionParameter, answer, timer);
        break;
      default:
        setNextQuestion(answer, timer);
    }
  };

  const renderQuestionOptions = () =>
    options.map((x, i) => (
      <Option
        key={`${currQuestionIndex}${i}`}
        onClick={() => getOptionActionString(x.action, x.text)}
        textColor={x.textColor}
        backgroundColor={x.backgroundColor}
        backgroundHoverColor={x.backgroundHoverColor}
        borderColor={x.borderColor}
        className="suka"
      >
        {x.text}
      </Option>
    ));

  return (
    <Container isSuccessText={isSuccessText}>
      {renderQuestionOptions()}
    </Container>
  );
};
export default Closed;
